import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { forkJoin, map, of } from 'rxjs';

export const initialDataResolver = (route: ActivatedRouteSnapshot) => {
    const messagesService = inject(MessagesService);
    const navigationService = inject(NavigationService);
    const notificationsService = inject(NotificationsService);
    const quickChatService = inject(QuickChatService);
    const shortcutsService = inject(ShortcutsService);

    const isPolicyPage = route.firstChild?.routeConfig?.path?.startsWith('policy') === true;
    if (isPolicyPage) {
        // Policy pages only need navigation (menu); skip messages, notifications, quick chat, shortcuts for faster load
        return navigationService.get().pipe(
            map((nav) => [nav, [], [], [], []])
        );
    }

    return forkJoin([
        navigationService.get(),
        messagesService.getAll(),
        notificationsService.getAll(),
        quickChatService.getChats(),
        shortcutsService.getAll(),
    ]);
};
